module.exports = __webpack_public_path__ + "img/fillMainInfo.15562bc2.gif";